import { Platform } from 'react-native';
import PantryTypes from '../../constants/PantryTypes';

// cross-platform asset path resolution doesn't like the ../../ here
const ICON_PATH = 'assets/images/marker_icons';

const MARKER_ICON =
  Platform.OS === 'web'
    ? {
        plentiful_pantry_qr: require(`../../${ICON_PATH}/category/plentiful_pantry_qr.svg`),
        plentiful_pantry_non_qr: require(`../../${ICON_PATH}/category/plentiful_pantry_non_qr.svg`),
        other_pantry_verified: require(`../../${ICON_PATH}/category/other_pantry_verified.svg`),
        other_pantry_unverified: require(`../../${ICON_PATH}/category/other_pantry_unverified.svg`),
        hot_meal_verified: require(`../../${ICON_PATH}/category/hot_meal_verified.svg`),
        hot_meal_unverified: require(`../../${ICON_PATH}/category/hot_meal_unverified.svg`),
        non_food_verified: require(`../../${ICON_PATH}/category/non_food_verified.svg`),
        non_food_unverified: require(`../../${ICON_PATH}/category/non_food_unverified.svg`),
      }
    : {
        plentiful_pantry_qr: require(`../../${ICON_PATH}/category/plentiful_pantry_qr.png`),
        plentiful_pantry_non_qr: require(`../../${ICON_PATH}/category/plentiful_pantry_non_qr.png`),
        other_pantry_verified: require(`../../${ICON_PATH}/category/other_pantry_verified.png`),
        other_pantry_unverified: require(`../../${ICON_PATH}/category/other_pantry_unverified.png`),
        hot_meal_verified: require(`../../${ICON_PATH}/category/hot_meal_verified.png`),
        hot_meal_unverified: require(`../../${ICON_PATH}/category/hot_meal_unverified.png`),
        non_food_verified: require(`../../${ICON_PATH}/category/non_food_verified.png`),
        non_food_unverified: require(`../../${ICON_PATH}/category/non_food_unverified.png`),
      };

/**
 * Using the data returned from the API, choose the most appropriate marker icon. This categorization
 * logic must match the logic in the backend, currently in `searchAlgoliaPantryIndex`.
 */
export const getMarkerIcon = (pantry) => {
  if (pantry.type === PantryTypes.plentiful_provider) {
    return pantry.use_qr_codes ? MARKER_ICON.plentiful_pantry_qr : MARKER_ICON.plentiful_pantry_non_qr;
  }

  if (pantry.pantry_type === PantryTypes.plentiful_provider) {
    return pantry.use_qr_codes ? MARKER_ICON.plentiful_pantry_qr : MARKER_ICON.plentiful_pantry_non_qr;
  }

  if (pantry.pantry_type === PantryTypes.other_pantry) {
    return pantry.verified ? MARKER_ICON.other_pantry_verified : MARKER_ICON.other_pantry_unverified;
  }

  if (pantry.pantry_type === PantryTypes.hot_meal) {
    return pantry.verified ? MARKER_ICON.hot_meal_verified : MARKER_ICON.hot_meal_unverified;
  }

  if (pantry.pantry_type === PantryTypes.non_food) {
    return pantry.verified ? MARKER_ICON.non_food_verified : MARKER_ICON.non_food_unverified;
  }

  console.log(`Unknown pantry type: ${pantry.pantry_type}`);
};
